import { toQueryParams } from '@shared/utils/url';
import { flatten } from 'lodash-es';
import { v2, v3 } from '@/api/client';
import { createQueryClause } from '../query/queryClause';

export const fetchCurrentUser = () =>
  v3.get<UserDto>('user/me?include=image&include=roles');

export const fetchUser = (id: string | undefined, params?: FetchUserParams) => {
  if (!id) {
    return Promise.resolve(undefined);
  }
  return v2.get<UserDto>(`user/${id}${toQueryParams(params)}`);
};

export const fetchUsers = (
  criteria?: UserCriteria,
  params: ListParams<UserInclude> = {}
) => {
  return v2
    .getPaginated<UserDto[]>(
      `user`,
      {
        query: createQueryClause(criteria),
        ...params,
      },
      {
        defaultValue: [],
      }
    )
    .then(flatten);
};

export const createUser = (data: Partial<UserDto>) =>
  v2.post<UserDto>('user?send_user_invite=true', data);

export const updateUser = (user: UserDto) =>
  v2.put<UserDto>(`user/${user.id}`, user);

export const softDeleteUser = (id: string) =>
  v2.remove(`user/${id}?soft_delete=true`);

interface PasswordChange {
  password: string;
  confirmation: string;
}

interface ChangePasswordOptions extends PasswordChange {}

export const changePassword = (passwordInfo: ChangePasswordOptions) =>
  v2.put<void>('user/me/password', passwordInfo, { responseType: 'void' });

interface ChangePasswordForUserOptions {
  userId: string;
  password: PasswordChange;
}

export const changePasswordForUser = ({
  userId,
  password,
}: ChangePasswordForUserOptions) =>
  v2.put<void>(`user/${userId}/password`, password, {
    responseType: 'void',
  });

export const fetchRoles = (realmId: string) =>
  v2.get<RoleDto[]>(`role${toQueryParams({ realm: realmId })}`, {
    defaultValue: [],
  });
